<template>
<div class="side-wrapper" :style="{ height: height + 'px' }">
    <div class="side-item" :class="{ active: sideIndex == index && !item.children }" v-for="(item, index) in sideList" v-if="item.isShow" :key="index">
        <div class="box" style="align-items: center;">
            <div @click="changeSideItem(index, item.router)">{{ item.name }}</div>
            <div v-if="item.children" class="iconfont icon-up iconShow"></div>
        </div>

        <div v-if="item.children && item.showChild">
            <div class="child-item" v-for="(_item, ind) in sideList[index].children" :key="ind" :class="{ active: childrenInd == ind && sideIndex == index }" @click="changeChildrenItem(ind, _item.router, _item)">
                <div>{{ _item.name }}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
var that;
import api from "../api/index";
const {
    educationPermissionCheck, //查询是否教育局
} = api;
export default {
    name: "sidebar",
    data() {
        return {
            height: window.document.body.offsetHeight - 60
        };
    },
    computed: {
        sideList() {

            return that.$store.state.sideList;
        },
        sideIndex: {
            get() {
                return that.$store.state.sideIndex;
            }
        },
        childrenInd: {
            get() {
                return that.$store.state.childrenInd;
            }
        }
    },
    methods: {
        handleResize(event) {
            this.height = document.documentElement.clientHeight - 60;
        },
        changeSideItem(index, router) {
            var item = that.sideList[index];
            if (item.children) {
                if (that.sideList[index].showChild) {
                    that.sideList[index].showChild = false;
                    this.$store.commit("updateSideIndex", index);
                } else {
                    //循环  关闭所有children
                    that.sideList.forEach((item, i_index) => {
                        if (i_index == index) {
                            item.showChild = true;
                        } else {
                            item.showChild = false;
                        }
                    });
                    this.$router.replace({
                        name: that.sideList[index].children[this.childrenInd].router
                    });
                    this.$store.commit("updateSideIndex", index);
                }
            } else {
                if (item.isNewWindow) {
                    let location = window.location + "";
                    window.open(location.split("#")[0] + "#/" + router);
                    return;
                }
                that.sideList.forEach(item => {
                    item.showChild = false;
                });
                this.$store.commit("updateSideIndex", index);
                if (item.path) {
                    //党委联席会议及议事厅
                    this.$router.replace({
                        path: item.path
                    })
                } else {
                    this.$router.replace({
                        name: router
                    });
                }
            }
        },
        async changeChildrenItem(index, router, _item) {
            console.log(index, router, _item)
            if (_item.isNewWindow) {
                let location = window.location + "";
                window.open(location.split("#")[0] + "#/" + router);
                return;
            }
            if (router == 'epidemicForm') {
                let location = window.location + "";
                window.open(location.split("#")[0] + "#/Shequ/" + router);
                return;
            }
            //信息共享
            if (router == 'bdcxxgx') {
                window.open("https://bkhl.baiteda.cn/apps/desktop/multipleTabs/sapp/app_golmzaupeo/sapp_vqwlqoh17e/box/apphomede-fault");
                return;
            }
            if (router == "educationlist") {
                if (localStorage["uid"]) {
                    let url = educationPermissionCheck + localStorage["uid"]
                    let res = await this.$post(url, {});
                    console.log(res)
                    if (res.isSucceed && res.code == 1) {
                        this.$store.commit("updateChildrenInd", index);
                        if (router.indexOf("?")) {
                            let params = {
                                comeType: router.split("=")[1],
                            };
                            console.log(this.$store.state.apptype)
                            if (router == 'miniProgram?1') {
                                params.title = this.$store.state.apptype == 'ctt' ? '丛台先锋' : '先锋e家'
                            }
                            if (router == 'miniProgram') {
                                params.title = this.$store.state.apptype == 'ctt' ? '丛台通' : '民生通'
                            }
                            //党员先锋/志愿之星
                            this.$router.replace({
                                name: router.split("?")[0],
                                query: params
                            });
                        } else {
                            this.$router.replace({
                                name: router
                            });
                        }
                    } else {
                        this.$Message.info("您无此权限");
                    }
                } else {
                    this.$Message.info("您无此权限");
                }
            } else {
                this.$store.commit("updateChildrenInd", index);
                if (router.indexOf("?")) {
                    let params = {
                        comeType: router.split("=")[1],
                    };
                    console.log(this.$store.state.apptype)
                    if (router == 'miniProgram?1') {
                        params.title = this.$store.state.apptype == 'ctt' ? '丛台先锋' : '先锋e家'
                    }
                    if (router == 'miniProgram') {
                        params.title = this.$store.state.apptype == 'ctt' ? '丛台通' : '民生通'
                    }
                    //党员先锋/志愿之星
                    this.$router.replace({
                        name: router.split("?")[0],
                        query: params
                    });
                } else {
                    this.$router.replace({
                        name: router
                    });
                }
            }

        }
    },
    created() {
        that = this;
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    }
};
</script>

<style lang="less" scoped>
.side-wrapper {
    width: 150px;
    padding: 20px 0;
    border-right: 1px solid #ddd;
    background: #fff;
    position: fixed;
    left: 0;
    /* font-size:15px */
    font-size: 16px;
    overflow-y: scroll;
}

.side-wrapper::-webkit-scrollbar {
    width: 0;
}

.side-item {
    width: 150px;
    float: right;
    text-align: left;
    padding: 8px 0 8px 30px;
    margin-bottom: 20px;
    color: #4b4b4b;
}

.side-item:last-child {
    margin-bottom: 0;
}

.child-item {
    margin-top: 30px;
    margin-left: -30px;
    padding-left: 40px;
    color: #999;
    font-size: 16px;
}

.active {
    position: relative;
    color: #d22b2b;

    /*边框颜色：上 右 下 左 （从上边框开始 顺时针方向）*/
    &::after {
        content: "";
        position: absolute;
        height: 100%;
        width: 3px;
        left: 0;
        top: 0;
        background-color: #d22b2b;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }
}

.iconShow {
    /* padding-left:30px */
    color: #aaa;
    padding-left: 20px;
    font-size: 14px;
}
</style>
